import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
import { defineComponent as _defineComponent } from 'vue';
import { onBeforeMount, ref, watch, nextTick } from 'vue';
import { useRepositories } from '@/plugins/repositories';
import { useTelemetry } from '@/plugins/telemetry';
import { useAuth } from '@/plugins/auth';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup: function setup(__props) {
    var route = useRoute();
    var router = useRouter();
    var $auth = useAuth();
    var $repositories = useRepositories();
    var $telemetry = useTelemetry();
    var category = ref({});
    var subcategories = ref([]);
    onBeforeMount(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var categoryId;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            if ($auth.permissions.formatDownload) {
              _context.n = 1;
              break;
            }
            router.push('/');
            return _context.a(2);
          case 1:
            categoryId = route.params.id;
            _context.n = 2;
            return $repositories.format.getCategory(categoryId);
          case 2:
            category.value = _context.v;
            _context.n = 3;
            return $repositories.format.getSubcategories(categoryId);
          case 3:
            subcategories.value = _context.v;
          case 4:
            return _context.a(2);
        }
      }, _callee);
    })));
    watch(subcategories, function (newVal, oldVal) {
      if (newVal.length > 0 && oldVal.length === 0) {
        nextTick(function () {
          var _document$querySelect;
          var target = document.getElementById(decodeURI(route.hash.replace('#', '')));
          if (!target) return;
          var rect = target.getBoundingClientRect();
          var searchBarHeight = ((_document$querySelect = document.querySelector('nav#search-bar')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.clientHeight) || 0;
          window.scrollBy({
            top: rect.top - searchBarHeight,
            behavior: 'smooth'
          });
        });
      }
    });
    function onClickCategory(category) {
      $telemetry.sendClickTelemetry({
        button: 'format-subcategories__category',
        params: {
          format: {
            subcategories: {
              category: category
            }
          }
        }
      }, route);
    }
    function onClickDownload(file) {
      $telemetry.sendClickTelemetry({
        button: 'format-subcategories__file',
        params: {
          format: {
            subcategories: {
              file: file
            }
          }
        }
      }, route);
    }
    function onClickDocument(document) {
      $telemetry.sendClickTelemetry({
        button: 'format-subcategories__document',
        params: {
          format: {
            subcategories: {
              document: document
            }
          }
        }
      }, route);
    }
    return {
      __sfc: true,
      route: route,
      router: router,
      $auth: $auth,
      $repositories: $repositories,
      $telemetry: $telemetry,
      category: category,
      subcategories: subcategories,
      onClickCategory: onClickCategory,
      onClickDownload: onClickDownload,
      onClickDocument: onClickDocument
    };
  }
});